
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as appqOuFeTWQ_k965Emc69uIrBxwLUmgNKAfVspRCbb4KzYMeta } from "/usr/src/app/pages/app.vue?macro=true";
import { default as aboutGM5UHk7qsam6f1oSc2Z49RGj4f4aP_rVMkr_45wA6YtokMeta } from "/usr/src/app/pages/about.vue?macro=true";
import { default as indexdP7zTFRl7aZq2Pc08cwkTh9_Xhz5atMbl890jb4bLIEMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as _91link_93ZsQHbZ3RHfurLQz0kOc5CaObSTHErZMWe6tPiTYETdIMeta } from "/usr/src/app/pages/[link].vue?macro=true";
import { default as fest4lPyslPI2AHq02LbJiTTDjPcj7jP4AxkX5l7BnJhsS2T0Meta } from "/usr/src/app/pages/fest4l.vue?macro=true";
import { default as ui_45kit5W7slgFeM4Jmr3UnXa7ZCzu3yoYCFeIT9kiPclQplGQMeta } from "/usr/src/app/pages/ui-kit.vue?macro=true";
import { default as servicecfWFsT9doCLO4vfVlXzam_Al_45v5N0qIlh1jFFNU6CnQMeta } from "/usr/src/app/pages/service.vue?macro=true";
import { default as sitemap67B_45paIJmJekrYwT2_45RE7RuiS_JsiMY2_45X00RxqCHZwMeta } from "/usr/src/app/pages/sitemap.vue?macro=true";
import { default as indexb9dLhWKV_hdZEkwDWzx2yuGS_ZBLlFnH6n0WnvGlgNcMeta } from "/usr/src/app/pages/blog/index.vue?macro=true";
import { default as indexDRCkb_QBLz965R17UIAbCH_45kXc6TwTJKzZEmPqs1GykMeta } from "/usr/src/app/pages/help/index.vue?macro=true";
import { default as indexSOGYUlNekjLExAdmdg47yizum7bBUTQ_u0Ksib56rGsMeta } from "/usr/src/app/pages/shop/index.vue?macro=true";
import { default as _91slug_93RDa6imw48EDyei7f0gx9ZCMNWahDgy9GpYYgaEbeIOwMeta } from "/usr/src/app/pages/blog/[slug].vue?macro=true";
import { default as petRpTJfAz6LWQPnh_wx7CERKkJMuQz3a7reyUI7pLGBYkMeta } from "/usr/src/app/pages/profile/pet.vue?macro=true";
import { default as editMJrvMn54b0Hv9CC4NxpiJ4_45E2f2CBxEphsU2CNmYK2YMeta } from "/usr/src/app/pages/profile/edit.vue?macro=true";
import { default as spb8jUwwyr4AUV11jDSHuU8nKkH9kgSGvqngNCVtDUfmWsMeta } from "/usr/src/app/pages/roadbook/spb.vue?macro=true";
import { default as ttkJ0hQOaJd_bCjlVKQH35oEnAuyf1v4lMp0B44161zyuEMeta } from "/usr/src/app/pages/roadbook/ttk.vue?macro=true";
import { default as katalog6CZQc3lp6XETW5z78ED0kJ0ogdWnK_fZP1ce0GkVreIMeta } from "/usr/src/app/pages/shop/katalog.vue?macro=true";
import { default as indexJ3GBYcK1GeaeFV88QYNqnZQT8rhGorrqL5b3oKSwinIMeta } from "/usr/src/app/pages/uslugi/index.vue?macro=true";
import { default as indexr8_45ZjgPPr1hdqJWjrZaI6RINCZD0kwZXqSyaTvO8oXMMeta } from "/usr/src/app/pages/clinics/index.vue?macro=true";
import { default as indexbYjd0RM4EZ1JzoPM3R_45wkMbw25gILbSV5xClx0stGDYMeta } from "/usr/src/app/pages/profile/index.vue?macro=true";
import { default as svaooWAlUOTTVZEPYauJOUz0WjCnfgzQFsCq7eFuMVC6VNoMeta } from "/usr/src/app/pages/roadbook/svao.vue?macro=true";
import { default as westVjquQGN1es6wdVH_ieaDzgD9pzWFJFE3cb2SWzDlzBQMeta } from "/usr/src/app/pages/roadbook/west.vue?macro=true";
import { default as indexdfRJnmf_45LY7qYFK34tIIVnodAuntn0aKJ8qBMpKzk14Meta } from "/usr/src/app/pages/roadbook/index.vue?macro=true";
import { default as _91_46_46_46rest_93BUUG3EMH3jnVqzYdOL2Z0BZLu5Ez2eTTL5XmwxMf9RQMeta } from "/usr/src/app/pages/shop/[...rest].vue?macro=true";
import { default as indexEs_45MKTfhfz6EOYPYaojzmvLIGiwAqRn_jgg8PSCkwKMMeta } from "/usr/src/app/pages/simptomy/index.vue?macro=true";
import { default as vet_45onboardingwqtYp_45rLBlz_453CcGTfKii8NN73FmacsoKesgY8s6TMcMeta } from "/usr/src/app/pages/vet-onboarding.vue?macro=true";
import { default as booking23dMji7MrVYjnL_J7hqJXweCnQmcqjRBQK080LQ8Y70Meta } from "/usr/src/app/pages/widget/booking.vue?macro=true";
import { default as _91slug_93meP_45j39DRDGyyWCbSAbnY8o9V38JhiUHN8pjGrE_w9QMeta } from "/usr/src/app/pages/help/tag/[slug].vue?macro=true";
import { default as indexKmy3_45eb2dFaanYCf6feR_8szyp32D8ANvGseZszaW1sMeta } from "/usr/src/app/pages/help/vets/index.vue?macro=true";
import { default as _91slug_93tpq3QFHvU2tU9qP5Kbp2yILrTd19atEm2DI1iAyMeh0Meta } from "/usr/src/app/pages/simptomy/[slug].vue?macro=true";
import { default as _91slug_93MBpPPGnHrkmifpEh82POiHov1skHVS94nucP3tDD2PwMeta } from "/usr/src/app/pages/help/vets/[slug].vue?macro=true";
import { default as index1yljtfpOqmS9BOWwWGqkkV2kTUxIX8Y8Jf82YWNajtUMeta } from "/usr/src/app/pages/profile/ai/index.vue?macro=true";
import { default as vet_45registration_anB7T_45fAnW_pqQrYz2eP45lYQjXp_45YriTKHrjU2t7QMeta } from "/usr/src/app/pages/vet-registration.vue?macro=true";
import { default as indexenvDSGS9ww8uNgNNVUtk4cEPJLPg_F9qqISXS_45soOy8Meta } from "/usr/src/app/pages/veterinars/index.vue?macro=true";
import { default as clinic_45onboarding71g0w7HHXIxspI6_yhCv_9Qepyhnn9xyrYck2THHoHgMeta } from "/usr/src/app/pages/clinic-onboarding.vue?macro=true";
import { default as dermatologynBqYkhXcF6eQA9Q2VoTiXmts_45ylr6M2bFCWDgokGbVIMeta } from "/usr/src/app/pages/guide/dermatology.vue?macro=true";
import { default as index7f3c2VkUWpnCwzf6W7_YJqITrzhIRxJX6LYQf_lpHI0Meta } from "/usr/src/app/pages/help/owners/index.vue?macro=true";
import { default as _91token_93Bn_45PGFY9Aiha3ISrM8zlVeVj5yG_45GKWVCOr4yGbxNiEMeta } from "/usr/src/app/pages/share/doc/[token].vue?macro=true";
import { default as _91token_93RoxJ_mHdEJIJYE4UT61aSLvmnKyusevKUjCvBIrJUcwMeta } from "/usr/src/app/pages/share/pet/[token].vue?macro=true";
import { default as _91token_93z3Et9pG4QKXq7_45XMIZ4k3EEVf1eGB9wW6VelvMF_45XVwMeta } from "/usr/src/app/pages/shop/bron/[token].vue?macro=true";
import { default as _91slug_93700qL8o_t2ebmOxfJIg_45H_8WsBKq00d3Q2RsPpeOpZIMeta } from "/usr/src/app/pages/shop/tovar/[slug].vue?macro=true";
import { default as _91slug_93rkeOqdgFmvuluAMA84BlCoQG4bT4MGLy_O5QGNDrZsEMeta } from "/usr/src/app/pages/help/owners/[slug].vue?macro=true";
import { default as indexefbhx9mtCGBwUqgh_45wTNKvvwHbA0F_akk3yDtTIHaFIMeta } from "/usr/src/app/pages/shop/korzina/index.vue?macro=true";
import { default as clinic_45registrationg6Dmc1iouSeLUD_45ZdqusLyNIXeyFcKm_B8IhUV5PzBkMeta } from "/usr/src/app/pages/clinic-registration.vue?macro=true";
import { default as editOTEWDVx_45lruMlMgs5JGxG0iKG0Vf2iyD2Q5WHnbzEKkMeta } from "/usr/src/app/pages/profile-clinic/edit.vue?macro=true";
import { default as editMtbSMEQl2_45j1FbZ8TlWLq67YuX_UGL9jD8vEBHAeuzYMeta } from "/usr/src/app/pages/profile-doctor/edit.vue?macro=true";
import { default as _91id_93o_puBNB5gkHSj8y82Vj6z8yqu744RmMfrLWP33HN5_45sMeta } from "/usr/src/app/pages/profile/orders/[id].vue?macro=true";
import { default as _91brand_93z_453kuQ1Z5ok2frwQDtGoIPwxW2JayTm8wqvZ92EdTOcMeta } from "/usr/src/app/pages/shop/brendy/[brand].vue?macro=true";
import { default as _91id_93V00za3oAMQOBaixgmFfYcBQxZvB9sKB4vLvVem2vUZUMeta } from "/usr/src/app/pages/widget/doctors/[id].vue?macro=true";
import { default as indexmFm0jyxiNHvYqXWqBhh_1Fwehn6oGoKP_45qi4KF9BStAMeta } from "/usr/src/app/pages/clinics/[city]/index.vue?macro=true";
import { default as indexz4j1Q3_45TpWRWt2Yme7aEmZAqp45zYILRJzASkQ8wzxcMeta } from "/usr/src/app/pages/profile-clinic/index.vue?macro=true";
import { default as indexyhO8k3ipjBByafKXLG_45P3proiD83NdUD_BRczaQ06zMMeta } from "/usr/src/app/pages/profile-doctor/index.vue?macro=true";
import { default as indexQu8IuAAbaRWCx4Tp50Al36a9nPclPsxBhgDlM3IKP38Meta } from "/usr/src/app/pages/profile/orders/index.vue?macro=true";
import { default as indexmLpngAcVzAkUQmWJcDUhxWEi3dM_45qPVbcbMyx3aifZIMeta } from "/usr/src/app/pages/shop/[section]/index.vue?macro=true";
import { default as failvnGJfvAMCQgoKvWXsKZTQSGrf2kC_nATUtuhxxDiPRAMeta } from "/usr/src/app/pages/book-appointment/fail.vue?macro=true";
import { default as widget51XqNXkX7jx5jd_fooNF_oarLQ_45oG2I4EExV3hDorHwMeta } from "/usr/src/app/pages/profile-doctor/widget.vue?macro=true";
import { default as indexZoKqX7c_45CwMfg1fEYsMZjWmBwcumDJH7DRjeU_AMAGIMeta } from "/usr/src/app/pages/profile/history/index.vue?macro=true";
import { default as _91_46_46_46where_93hTehU51peoxQ0D2xVa2Hy4ab9icI5BXAzXvJpFRNQuMMeta } from "/usr/src/app/pages/veterinars/[...where].vue?macro=true";
import { default as indexBQVhgAk0hKl_459Cbfy35F_45_ljOb4fVkWadb3HF6v1xjwMeta } from "/usr/src/app/pages/book-appointment/index.vue?macro=true";
import { default as historyAu5GLAM7XXmw4TSi2fnuWLqEDzzKRbmvzFBfrFmcFjMMeta } from "/usr/src/app/pages/profile-clinic/history.vue?macro=true";
import { default as reviewsUtmszsqidWrK5dydjOX4vt3_60E2K1868Y96J6b36VAMeta } from "/usr/src/app/pages/profile-clinic/reviews.vue?macro=true";
import { default as reviewszsJT9ZL9nOYKNYIi8XJ_L02bx_PJ9VbYxtzJaKugEa0Meta } from "/usr/src/app/pages/profile-doctor/reviews.vue?macro=true";
import { default as indexxUAXYPSVFfzXopnnk8ITErtryB6eiG4p0a_Qm1N9WFIMeta } from "/usr/src/app/pages/uslugi/[segment]/index.vue?macro=true";
import { default as index3QPMdFMHGXESHhQZvJULtpU2mh2TWwxlSKNsS4hGLTEMeta } from "/usr/src/app/pages/veterinar-rating/index.vue?macro=true";
import { default as _91id_93_45_91slug_93MXMXP433Som6x7q539syf88zhAx_454fhqhVTmyFTPT4wMeta } from "/usr/src/app/pages/veterinars/[id]-[slug].vue?macro=true";
import { default as _91clinic_930PLJbwaBANjXK_45oUfHoeKwricNSeLql8gm2uu9_03IIMeta } from "/usr/src/app/pages/clinics/[city]/[clinic].vue?macro=true";
import { default as kruglosutochnyeSDg5_xhP9oHbraCx3rA3vsgIU0SCI1KAnIDTA0cYydUMeta } from "/usr/src/app/pages/clinics/kruglosutochnye.vue?macro=true";
import { default as oferta_accept0Mgl6Kz1ClBUXbm_45YJwlEs64a_kQqM_mdpJ6yS1DLr4Meta } from "/usr/src/app/pages/documents/oferta_accept.vue?macro=true";
import { default as review_45policyZVxBMzrOG2SybfdH711Dwb85mtBLxnbuToMzYkYgUhYMeta } from "/usr/src/app/pages/documents/review-policy.vue?macro=true";
import { default as services61oM61XmpdM44ao8_45pqD9KeDTyRetzgYZ1vd9puIPHIMeta } from "/usr/src/app/pages/profile-clinic/services.vue?macro=true";
import { default as showcaseggulTt8Nl5LWHC0AgPvveeYWWklBLzmp8FHZgc66kOIMeta } from "/usr/src/app/pages/profile-clinic/showcase.vue?macro=true";
import { default as schedulehNvQ45klYrZuRgSDYd_Yu5ALAvlCCXxJ0HxRD7OYqWYMeta } from "/usr/src/app/pages/profile-doctor/schedule.vue?macro=true";
import { default as indexG2DawEp1_45VmCOYjmosjPo6ziUchO5wwph1TvzzynvL4Meta } from "/usr/src/app/pages/profile/documents/index.vue?macro=true";
import { default as oformleniei4Xe6Atj5c8BiMMJOXd2fMjntP1OUPOV3ProS5UiQBIMeta } from "/usr/src/app/pages/shop/korzina/oformlenie.vue?macro=true";
import { default as _91node_93wWvyVWgopz7nVAd0_45MhA7NOrb0sSoraU2MB1lN_45cZeAMeta } from "/usr/src/app/pages/uslugi/[segment]/[node].vue?macro=true";
import { default as failA2MkXUAwyCbr__aEFMO5ik0r1n_xEF6RNyvqjjURqcYMeta } from "/usr/src/app/pages/widget/doctor/[id]/fail.vue?macro=true";
import { default as successgXDUn0mHCsDPZQMWvRSJ8Jg8MI28wslD9Upzk4C0n9AMeta } from "/usr/src/app/pages/book-appointment/success.vue?macro=true";
import { default as privacy_45policy6hsuo7aP_Fw7K3f7xLk6Khe4iycZA2IUy1_c1niEnAMMeta } from "/usr/src/app/pages/documents/privacy-policy.vue?macro=true";
import { default as terms_45of_45usageVq949BXA8j7sxORiMikuj1qeU5EX2phSYm2Zh2upnr4Meta } from "/usr/src/app/pages/documents/terms-of-usage.vue?macro=true";
import { default as educationbFnjzjeKnDJns_Te2S6_452visthSHLySWy1zHOsaT_d0Meta } from "/usr/src/app/pages/profile-clinic/education.vue?macro=true";
import { default as education0ULtRp_45mFIhV0n8J_V6qm2lzlN9vjq1N0nD9_g0DLEcMeta } from "/usr/src/app/pages/profile-doctor/education.vue?macro=true";
import { default as index40cJSBAMgYEZT77COcGem1bNavNGxYnE9WFEYjshjGcMeta } from "/usr/src/app/pages/widget/doctor/[id]/index.vue?macro=true";
import { default as requisitesuvyp2_wI6MRzE_45Vi_45jY_uGz2XbIu9RUqjTuNAiBRnMYMeta } from "/usr/src/app/pages/profile-clinic/requisites.vue?macro=true";
import { default as statisticsIJrttnjuiIC6FcCwxVR_45V2N60dZ8IBAvB44JvOsj6xkMeta } from "/usr/src/app/pages/profile-clinic/statistics.vue?macro=true";
import { default as statisticsvkQvFF4upyIMG4XXCouKwu2qRpCD22Sew9shFRdgv_EMeta } from "/usr/src/app/pages/profile-doctor/statistics.vue?macro=true";
import { default as account_45deletionYnBI_45_45CG94d5XM3_45wsJI_451t6uw5qqNuPY0DPRXoar8wMeta } from "/usr/src/app/pages/documents/account-deletion.vue?macro=true";
import { default as newJxgygup_R20WD935aZdqtSio7YhCg570RPyfTNvUgz8Meta } from "/usr/src/app/pages/profile-clinic/doctors/new.vue?macro=true";
import { default as _91id_93gym9mEFnYMmr_IRs0kh6fo0XMWUGPVJiD_ZUEhmOZQoMeta } from "/usr/src/app/pages/profile-clinic/orders/[id].vue?macro=true";
import { default as indexmJFPzS1gfoZZ_45HxsY5b0KH8CeRny6Q0iVUjvWx8cMFcMeta } from "/usr/src/app/pages/profile/history/[id]/index.vue?macro=true";
import { default as bookingqj1EQvjmBeVxoap8yzBt1fsbY_4561RnDURHkexUM6AGsMeta } from "/usr/src/app/pages/widget/doctor/[id]/booking.vue?macro=true";
import { default as successYg1aTvhBTD0aVbprgwN_45ODqSPFG3MfyyTpGQ15zOyoQMeta } from "/usr/src/app/pages/widget/doctor/[id]/success.vue?macro=true";
import { default as _91slug_93sFDDm_45CQNECiIJwE41f14EMKUHK7e3PemEG0JmYb03wMeta } from "/usr/src/app/pages/clinics/[city]/metro/[slug].vue?macro=true";
import { default as _91slug_93UzrKpsx9JjsjmLSG_abY9FuGFmQSqXTHwH8iVWqArlEMeta } from "/usr/src/app/pages/clinics/[city]/okrug/[slug].vue?macro=true";
import { default as _91slug_93fjH_45oYO4mA___45OFWKKORsmNLzc5VIU6QGpPuuQdcRY4Meta } from "/usr/src/app/pages/clinics/[city]/rayon/[slug].vue?macro=true";
import { default as indexsUPTxbvyTRMGgRcR9gQKlRpBdrVpDJZTgxk9S_45TUJmoMeta } from "/usr/src/app/pages/profile-clinic/orders/index.vue?macro=true";
import { default as indexzcpJE3Ukxr9NVNW_M3JEcn9A5NsRskmgAHkYEwNkgaEMeta } from "/usr/src/app/pages/profile-clinic/widget/index.vue?macro=true";
import { default as report6afd_45nj_456KiPdPHS1NMd7MRAZHPBSPvx3zx1pA7s5IIMeta } from "/usr/src/app/pages/profile/history/[id]/report.vue?macro=true";
import { default as _91_46_46_46where_93wOj2utQ1cT7tpHxO6Q8u6yZBEKHa5pStQ0HvB1kVlm0Meta } from "/usr/src/app/pages/veterinar-rating/[...where].vue?macro=true";
import { default as accreditation_45infoXGJiLp4UHPWJ67hLVuyzC7326fsUaKZHRFfZQwMNIEsMeta } from "/usr/src/app/pages/documents/accreditation-info.vue?macro=true";
import { default as index6mrXNohdFExYXzItzOGUHUD0qN94CRkbKA7lkGLvazEMeta } from "/usr/src/app/pages/profile-clinic/doctors/index.vue?macro=true";
import { default as notifications6hVCiwG3aCWAoomaeCX35PK7j9ACQk0UxH8oDnnBSRMMeta } from "/usr/src/app/pages/profile-clinic/notifications.vue?macro=true";
import { default as indexgkekFZhyurAM7TQCOasIWF7TYCQMqF2NxUClYOIvOOwMeta } from "/usr/src/app/pages/profile-doctor/history/index.vue?macro=true";
import { default as schedule_45datep_45Eo5FgCNL4UVZVs2SWVVKjB7OgaFtEuowqKjHbEEcEMeta } from "/usr/src/app/pages/profile-doctor/schedule-date.vue?macro=true";
import { default as indexR5np3PUWxHM7cD1i8s6Jm0fiD6uBYFGoi9CpAdgl4y0Meta } from "/usr/src/app/pages/profile-clinic/finances/index.vue?macro=true";
import { default as _91slug_93VZ_epLqunfA4LWW57ZY5xagBT_8Vbiex4HaksEQJW5QMeta } from "/usr/src/app/pages/profile-clinic/preview/[slug].vue?macro=true";
import { default as previewQl3kSGuFMgOyguMXsMHY_45qSdyHFYR_45lHK4jdoqw7x5sMeta } from "/usr/src/app/pages/profile-clinic/widget/preview.vue?macro=true";
import { default as tariffsYy1rYmtc0YnBnHYN_45hqnLnZRup5kfEumwSBdaCd89dgMeta } from "/usr/src/app/pages/profile-clinic/widget/tariffs.vue?macro=true";
import { default as indexqepbqrJiT69vC8DMuWU37VYUH0L_2jktRdtnGoL3HYoMeta } from "/usr/src/app/pages/profile-doctor/finances/index.vue?macro=true";
import { default as _91slug_93VbTF32Y2Q6Cij6fTsH3osZV9PngVW0C8TeQFJlo8HEkMeta } from "/usr/src/app/pages/profile-doctor/preview/[slug].vue?macro=true";
import { default as indexkroGwJ1zMATseCpRoC7J80UV497XuynEqvST4pq27U4Meta } from "/usr/src/app/pages/veterinars/[city]/vyesd/index.vue?macro=true";
import { default as indexb_kR2ojMaZvF3S1igljZlI1O3XPM1Ciam41ZFyI86B4Meta } from "/usr/src/app/pages/vyzov-veterinara-na-dom/index.vue?macro=true";
import { default as uspehmG7cVlS1CszVMJPW_Z5odES4sQkfk6qRo0bLxlhTj9MMeta } from "/usr/src/app/pages/vyzov-veterinara-na-dom/uspeh.vue?macro=true";
import { default as licenzionnyj_45dogovorp_45DwWQWUdULn2WeaSrtpzYVuq1bENlvZo0ZvfHsRsekMeta } from "/usr/src/app/pages/documents/licenzionnyj-dogovor.vue?macro=true";
import { default as historyyNvwSMCn0VbOuwNKNKBrBcn5KyB4Oaf4_4gGWsXlnl4Meta } from "/usr/src/app/pages/profile-clinic/doctors/history.vue?macro=true";
import { default as _91city_93GRe37TCSqmJ_Xih_45L_45LznxfOudF6_kyq_Afw335fbqQMeta } from "/usr/src/app/pages/vyzov-veterinara-na-dom/[city].vue?macro=true";
import { default as consent_45personal_45data8mFRxyzGyVGtV6DreKJMtOHIwjFwtTqURmU2ZdKvB3oMeta } from "/usr/src/app/pages/documents/consent-personal-data.vue?macro=true";
import { default as appointment_45_91id_93n6cmSRu4TgOaL0fmrJ_Kl227CpuYGEw0Qf5prnBontAMeta } from "/usr/src/app/pages/profile-clinic/appointment-[id].vue?macro=true";
import { default as schedulePrFI8NaBR__45It8hiPzQgfw7cdCBJG_45v_45ucnC1DQvUbAMeta } from "/usr/src/app/pages/profile-clinic/doctors/schedule.vue?macro=true";
import { default as enotCRIzdDXsr3jqtkhwKKC_45V_ynIi9Ujy1S2OkSwcWH_45p8Meta } from "/usr/src/app/pages/profile-clinic/integration/enot.vue?macro=true";
import { default as appointment_45_91id_93ay7fgZin6YbRY_45wahZ5Stk_fvZhE_45Q5OO_45s2CX_45pRQsMeta } from "/usr/src/app/pages/profile-doctor/appointment-[id].vue?macro=true";
import { default as partner_45programsZIyJXjpRajNrjHmzUWqRyGx83x2cIzxkqqbt287UXZwMeta } from "/usr/src/app/pages/profile-doctor/partner-programs.vue?macro=true";
import { default as referral_45program8gbfwu9UwluzCU6s2avLG6tq0ezwl0tTcdf6aPQDnOUMeta } from "/usr/src/app/pages/profile-doctor/referral-program.vue?macro=true";
import { default as indexy6tjx6syJa70uiF8gHmMFUFnSw91s4OMpGOSU4Y1lxQMeta } from "/usr/src/app/pages/shop/[section]/[category]/index.vue?macro=true";
import { default as ratolog_45promoEnw1ygMYzUcFBiVyAnIpT0fvOF3RmrM_45nKUKDC5cHrgMeta } from "/usr/src/app/pages/veterinars/online/ratolog-promo.vue?macro=true";
import { default as indexUUadQ0bOslq4rjWdg_g7uYaaGtx_45_Ib5VQnTZUxpsBoMeta } from "/usr/src/app/pages/profile-clinic/integration/index.vue?macro=true";
import { default as doctors_45onlinefvB7eKtSn4RVrWIazJndWQrRw9AUuioaZOZrst1ulSQMeta } from "/usr/src/app/pages/veterinars/online/doctors-online.vue?macro=true";
import { default as indexi114PZumgJiwqcvd5Dixob4_45st_vZ0Vm_n2kZGu66V8Meta } from "/usr/src/app/pages/profile-clinic/applications/index.vue?macro=true";
import { default as getwellPA9dNgpETO2T_Zm_45DOeS0JICy4MRuZpkFmlmJIeIA_sMeta } from "/usr/src/app/pages/profile-clinic/integration/getwell.vue?macro=true";
import { default as reportlbfqwGFLzmEwBhe7aTdxwKC4AqTgdIT7Ttr5ZJye5lQMeta } from "/usr/src/app/pages/profile-doctor/history/[id]/report.vue?macro=true";
import { default as _91animal_93lTikH6ogKrhEIJFQ8koUqsV1QdZcNcguCEnq97sPiEAMeta } from "/usr/src/app/pages/shop/[section]/[category]/[animal].vue?macro=true";
import { default as index4dl_45PBwj3yS1LlqhOpouXocG57wvKj_hm4GPbYm_89oMeta } from "/usr/src/app/pages/clinics/[city]/kruglosutochno/index.vue?macro=true";
import { default as veterinary_user_agreementRWU2x7o99__w_45kC8bp8DU1tvmP_45F77ple3aez1U5ZGAMeta } from "/usr/src/app/pages/documents/veterinary_user_agreement.vue?macro=true";
import { default as payout_45_91id_93C5Pf9At9FEtfy8xNGZox6He_45FA1sq7TwNsj8dnTYjEMMeta } from "/usr/src/app/pages/profile-clinic/finances/payout-[id].vue?macro=true";
import { default as online_45consultationsMrXsBj_45LD29hEP2r9PmHVYu6SuYm6K8AaUoZ7IGnMgcMeta } from "/usr/src/app/pages/profile-clinic/online-consultations.vue?macro=true";
import { default as payout_45_91id_93LofJq3nVbHrSJBLPbiEJ1BgyEPCuL_45_45LksZqS29suGAMeta } from "/usr/src/app/pages/profile-doctor/finances/payout-[id].vue?macro=true";
import { default as _91service_93_45_91animal_93mn1_45H65P3J1cUJYzRN3Yqizuw_DeZ4m9_hZvYvk53g4Meta } from "/usr/src/app/pages/uslugi/[segment]/[service]-[animal].vue?macro=true";
import { default as _91specialty_93Dq0kH3KdpoLhZKKoPhCuWRlDxNGWodxOn6TJFq_459pC8Meta } from "/usr/src/app/pages/veterinars/[city]/vyesd/[specialty].vue?macro=true";
import { default as consent_45personal_45data_45vetspJ05dJ8sXGM10c4StT9z1alXa1q6IOxwyUoUPRtCan4Meta } from "/usr/src/app/pages/documents/consent-personal-data-vets.vue?macro=true";
import { default as scheduletdKtGiFQTOkzakHDA7N7ktip9atZdRG26UFwEM6GA5YMeta } from "/usr/src/app/pages/profile-clinic/doctors/[id]/schedule.vue?macro=true";
import { default as vetmanageru1IZmYqx0m9p1wuzEk_2iD7aUXDrDiNpzKEIhpLMrWIMeta } from "/usr/src/app/pages/profile-clinic/integration/vetmanager.vue?macro=true";
import { default as index74B1gQlO_mic069D85FzrAUhnJvG_45YdRuY6GjOdL_45kgMeta } from "/usr/src/app/pages/profile-clinic/partner-programs/index.vue?macro=true";
import { default as _91slug_93t5e4ZY7Z6SqJiwIO58XBc8VakuyDJEB6um2trsbSV6kMeta } from "/usr/src/app/pages/profile-clinic/partner-programs/[slug].vue?macro=true";
import { default as view0SzeF60ifL0xS9jOv9K6gVFBtHdhaF_UUFBbxnnzHzoMeta } from "/usr/src/app/pages/profile-doctor/history/media/[id]/view.vue?macro=true";
import { default as _91kind_93_45_91id_93PO3LotcgYZMqmMOrR3dSZ77FhbCZIsr0thC_bND8gpsMeta } from "/usr/src/app/pages/profile-clinic/applications/[kind]-[id].vue?macro=true";
import { default as commission_45_91id_9305idMHOA4ttF8J0_456xq9ZX6pfpLXZxX5zfAVKWl5weQMeta } from "/usr/src/app/pages/profile-doctor/finances/commission-[id].vue?macro=true";
import { default as polzovatelskoe_45soglashenie_45so_45specAUeN_a_Q8S5AFuDaEqZm3xNe8LDwa1F8A5x_45TmfR0AQMeta } from "/usr/src/app/pages/documents/polzovatelskoe-soglashenie-so-spec.vue?macro=true";
import { default as uslovija_45dlja_45specialistov_45i_45klinik3f57QV0KFlOIb6hdjUo1bXcMx3rGlGU84eT3F29JNLMMeta } from "/usr/src/app/pages/documents/uslovija-dlja-specialistov-i-klinik.vue?macro=true";
import { default as besplatnaya_45onlayn_45konsultaciya_45veterinaraCKV0DZfBYeQZzUJciIhOCxEmcwFNj1vZPng4AKw58FEMeta } from "/usr/src/app/pages/veterinars/online/besplatnaya-onlayn-konsultaciya-veterinara.vue?macro=true";
import { default as component_45stubIzjaNWEhwusarYFpWl1xoeSJ1pcPz492fZ1FsTE5NCMMeta } from "/usr/src/app/node_modules/.pnpm/nuxt@3.19.0_@emnapi+core@1.11.3_@emnapi+runtime@1.11.3_@parcel+watcher@2.5.1_@types+nod_8011865266390b0e4bb9267123272e5c/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubIzjaNWEhwusarYFpWl1xoeSJ1pcPz492fZ1FsTE5NCM } from "/usr/src/app/node_modules/.pnpm/nuxt@3.19.0_@emnapi+core@1.11.3_@emnapi+runtime@1.11.3_@parcel+watcher@2.5.1_@types+nod_8011865266390b0e4bb9267123272e5c/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "app",
    path: "/app",
    component: () => import("/usr/src/app/pages/app.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/usr/src/app/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/pages/index.vue")
  },
  {
    name: "link",
    path: "/:link([a-zA-Z0-9][a-zA-Z0-9][a-zA-Z0-9][a-zA-Z0-9][a-zA-Z0-9][a-zA-Z0-9]?)/",
    meta: { ...(_91link_93ZsQHbZ3RHfurLQz0kOc5CaObSTHErZMWe6tPiTYETdIMeta || {}), ...{"middleware":"short-links"} },
    component: () => import("/usr/src/app/pages/[link].vue")
  },
  {
    name: "fest4l",
    path: "/fest4l",
    component: () => import("/usr/src/app/pages/fest4l.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/usr/src/app/pages/ui-kit.vue")
  },
  {
    name: "service",
    path: "/service",
    component: () => import("/usr/src/app/pages/service.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/usr/src/app/pages/sitemap.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/usr/src/app/pages/blog/index.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/usr/src/app/pages/help/index.vue")
  },
  {
    name: "shop",
    path: "/shop",
    component: () => import("/usr/src/app/pages/shop/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/usr/src/app/pages/blog/[slug].vue")
  },
  {
    name: "profile-pet",
    path: "/profile/pet",
    meta: {"middleware":"auth"},
    component: () => import("/usr/src/app/pages/profile/pet.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: { ...(editMJrvMn54b0Hv9CC4NxpiJ4_45E2f2CBxEphsU2CNmYK2YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile/edit.vue")
  },
  {
    name: "roadbook-spb",
    path: "/roadbook/spb",
    meta: spb8jUwwyr4AUV11jDSHuU8nKkH9kgSGvqngNCVtDUfmWsMeta || {},
    component: () => import("/usr/src/app/pages/roadbook/spb.vue")
  },
  {
    name: "roadbook-ttk",
    path: "/roadbook/ttk",
    meta: ttkJ0hQOaJd_bCjlVKQH35oEnAuyf1v4lMp0B44161zyuEMeta || {},
    component: () => import("/usr/src/app/pages/roadbook/ttk.vue")
  },
  {
    name: "shop-katalog",
    path: "/shop/katalog",
    meta: {"middleware":"shop-host-catalog"},
    component: () => import("/usr/src/app/pages/shop/katalog.vue")
  },
  {
    name: "uslugi",
    path: "/uslugi",
    component: () => import("/usr/src/app/pages/uslugi/index.vue")
  },
  {
    name: "clinics",
    path: "/clinics",
    component: () => import("/usr/src/app/pages/clinics/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: { ...(indexbYjd0RM4EZ1JzoPM3R_45wkMbw25gILbSV5xClx0stGDYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile/index.vue")
  },
  {
    name: "roadbook-svao",
    path: "/roadbook/svao",
    meta: svaooWAlUOTTVZEPYauJOUz0WjCnfgzQFsCq7eFuMVC6VNoMeta || {},
    component: () => import("/usr/src/app/pages/roadbook/svao.vue")
  },
  {
    name: "roadbook-west",
    path: "/roadbook/west",
    meta: westVjquQGN1es6wdVH_ieaDzgD9pzWFJFE3cb2SWzDlzBQMeta || {},
    component: () => import("/usr/src/app/pages/roadbook/west.vue")
  },
  {
    name: "roadbook",
    path: "/roadbook",
    meta: indexdfRJnmf_45LY7qYFK34tIIVnodAuntn0aKJ8qBMpKzk14Meta || {},
    component: () => import("/usr/src/app/pages/roadbook/index.vue")
  },
  {
    name: "shop-rest",
    path: "/shop/:rest(.*)*",
    meta: _91_46_46_46rest_93BUUG3EMH3jnVqzYdOL2Z0BZLu5Ez2eTTL5XmwxMf9RQMeta || {},
    component: () => import("/usr/src/app/pages/shop/[...rest].vue")
  },
  {
    name: "simptomy",
    path: "/simptomy",
    component: () => import("/usr/src/app/pages/simptomy/index.vue")
  },
  {
    name: "vet-onboarding",
    path: "/vet-onboarding",
    component: () => import("/usr/src/app/pages/vet-onboarding.vue")
  },
  {
    name: "widget-booking",
    path: "/widget/booking",
    meta: booking23dMji7MrVYjnL_J7hqJXweCnQmcqjRBQK080LQ8Y70Meta || {},
    component: () => import("/usr/src/app/pages/widget/booking.vue")
  },
  {
    name: "help-tag-slug",
    path: "/help/tag/:slug()",
    component: () => import("/usr/src/app/pages/help/tag/[slug].vue")
  },
  {
    name: "help-vets",
    path: "/help/vets",
    component: () => import("/usr/src/app/pages/help/vets/index.vue")
  },
  {
    name: "simptomy-slug",
    path: "/simptomy/:slug()",
    component: () => import("/usr/src/app/pages/simptomy/[slug].vue")
  },
  {
    name: "help-vets-slug",
    path: "/help/vets/:slug()",
    component: () => import("/usr/src/app/pages/help/vets/[slug].vue")
  },
  {
    name: "profile-ai",
    path: "/profile/ai",
    meta: { ...(index1yljtfpOqmS9BOWwWGqkkV2kTUxIX8Y8Jf82YWNajtUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile/ai/index.vue")
  },
  {
    name: "vet-registration",
    path: "/vet-registration",
    component: () => import("/usr/src/app/pages/vet-registration.vue")
  },
  {
    name: "veterinars",
    path: "/veterinars",
    meta: indexenvDSGS9ww8uNgNNVUtk4cEPJLPg_F9qqISXS_45soOy8Meta || {},
    component: () => import("/usr/src/app/pages/veterinars/index.vue")
  },
  {
    name: "clinic-onboarding",
    path: "/clinic-onboarding",
    component: () => import("/usr/src/app/pages/clinic-onboarding.vue")
  },
  {
    name: "guide-dermatology",
    path: "/guide/dermatology",
    component: () => import("/usr/src/app/pages/guide/dermatology.vue")
  },
  {
    name: "help-owners",
    path: "/help/owners",
    component: () => import("/usr/src/app/pages/help/owners/index.vue")
  },
  {
    name: "share-doc-token",
    path: "/share/doc/:token()",
    meta: _91token_93Bn_45PGFY9Aiha3ISrM8zlVeVj5yG_45GKWVCOr4yGbxNiEMeta || {},
    component: () => import("/usr/src/app/pages/share/doc/[token].vue")
  },
  {
    name: "share-pet-token",
    path: "/share/pet/:token()",
    meta: _91token_93RoxJ_mHdEJIJYE4UT61aSLvmnKyusevKUjCvBIrJUcwMeta || {},
    component: () => import("/usr/src/app/pages/share/pet/[token].vue")
  },
  {
    name: "shop-bron-token",
    path: "/shop/bron/:token()",
    meta: _91token_93z3Et9pG4QKXq7_45XMIZ4k3EEVf1eGB9wW6VelvMF_45XVwMeta || {},
    component: () => import("/usr/src/app/pages/shop/bron/[token].vue")
  },
  {
    name: "shop-tovar-slug",
    path: "/shop/tovar/:slug()",
    meta: _91slug_93700qL8o_t2ebmOxfJIg_45H_8WsBKq00d3Q2RsPpeOpZIMeta || {},
    component: () => import("/usr/src/app/pages/shop/tovar/[slug].vue")
  },
  {
    name: "help-owners-slug",
    path: "/help/owners/:slug()",
    component: () => import("/usr/src/app/pages/help/owners/[slug].vue")
  },
  {
    name: "shop-korzina",
    path: "/shop/korzina",
    component: () => import("/usr/src/app/pages/shop/korzina/index.vue")
  },
  {
    name: "clinic-registration",
    path: "/clinic-registration",
    component: () => import("/usr/src/app/pages/clinic-registration.vue")
  },
  {
    name: "profile-clinic-edit",
    path: "/profile-clinic/edit",
    meta: { ...(editOTEWDVx_45lruMlMgs5JGxG0iKG0Vf2iyD2Q5WHnbzEKkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile-clinic/edit.vue")
  },
  {
    name: "profile-doctor-edit",
    path: "/profile-doctor/edit",
    meta: { ...(editMtbSMEQl2_45j1FbZ8TlWLq67YuX_UGL9jD8vEBHAeuzYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile-doctor/edit.vue")
  },
  {
    name: "profile-orders-id",
    path: "/profile/orders/:id()",
    meta: { ...(_91id_93o_puBNB5gkHSj8y82Vj6z8yqu744RmMfrLWP33HN5_45sMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile/orders/[id].vue")
  },
  {
    name: "shop-brendy-brand",
    path: "/shop/brendy/:brand()",
    meta: _91brand_93z_453kuQ1Z5ok2frwQDtGoIPwxW2JayTm8wqvZ92EdTOcMeta || {},
    component: () => import("/usr/src/app/pages/shop/brendy/[brand].vue")
  },
  {
    name: "widget-doctors-id",
    path: "/widget/doctors/:id()",
    meta: _91id_93V00za3oAMQOBaixgmFfYcBQxZvB9sKB4vLvVem2vUZUMeta || {},
    component: () => import("/usr/src/app/pages/widget/doctors/[id].vue")
  },
  {
    name: "clinics-city",
    path: "/clinics/:city()",
    meta: indexmFm0jyxiNHvYqXWqBhh_1Fwehn6oGoKP_45qi4KF9BStAMeta || {},
    component: () => import("/usr/src/app/pages/clinics/[city]/index.vue")
  },
  {
    name: "profile-clinic",
    path: "/profile-clinic",
    meta: { ...(indexz4j1Q3_45TpWRWt2Yme7aEmZAqp45zYILRJzASkQ8wzxcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile-clinic/index.vue")
  },
  {
    name: "profile-doctor",
    path: "/profile-doctor",
    meta: { ...(indexyhO8k3ipjBByafKXLG_45P3proiD83NdUD_BRczaQ06zMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile-doctor/index.vue")
  },
  {
    name: "profile-orders",
    path: "/profile/orders",
    meta: { ...(indexQu8IuAAbaRWCx4Tp50Al36a9nPclPsxBhgDlM3IKP38Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile/orders/index.vue")
  },
  {
    name: "shop-section",
    path: "/shop/:section()",
    meta: indexmLpngAcVzAkUQmWJcDUhxWEi3dM_45qPVbcbMyx3aifZIMeta || {},
    component: () => import("/usr/src/app/pages/shop/[section]/index.vue")
  },
  {
    name: "book-appointment-fail",
    path: "/book-appointment/fail",
    component: () => import("/usr/src/app/pages/book-appointment/fail.vue")
  },
  {
    name: "profile-doctor-widget",
    path: "/profile-doctor/widget",
    meta: { ...(widget51XqNXkX7jx5jd_fooNF_oarLQ_45oG2I4EExV3hDorHwMeta || {}), ...{"middleware":["auth","doctor-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-doctor/widget.vue")
  },
  {
    name: "profile-history",
    path: "/profile/history",
    meta: { ...(indexZoKqX7c_45CwMfg1fEYsMZjWmBwcumDJH7DRjeU_AMAGIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile/history/index.vue")
  },
  {
    name: "veterinars-where",
    path: "/veterinars/:where(.*)*",
    component: () => import("/usr/src/app/pages/veterinars/[...where].vue")
  },
  {
    name: "book-appointment",
    path: "/book-appointment",
    component: () => import("/usr/src/app/pages/book-appointment/index.vue")
  },
  {
    name: "profile-clinic-history",
    path: "/profile-clinic/history",
    meta: {"middleware":["auth"]},
    component: () => import("/usr/src/app/pages/profile-clinic/history.vue")
  },
  {
    name: "profile-clinic-reviews",
    path: "/profile-clinic/reviews",
    meta: { ...(reviewsUtmszsqidWrK5dydjOX4vt3_60E2K1868Y96J6b36VAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile-clinic/reviews.vue")
  },
  {
    name: "profile-doctor-reviews",
    path: "/profile-doctor/reviews",
    meta: { ...(reviewszsJT9ZL9nOYKNYIi8XJ_L02bx_PJ9VbYxtzJaKugEa0Meta || {}), ...{"middleware":["auth","doctor-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-doctor/reviews.vue")
  },
  {
    name: "uslugi-segment",
    path: "/uslugi/:segment()",
    component: () => import("/usr/src/app/pages/uslugi/[segment]/index.vue")
  },
  {
    name: "veterinar-rating",
    path: "/veterinar-rating",
    component: () => import("/usr/src/app/pages/veterinar-rating/index.vue")
  },
  {
    name: "veterinars-id-slug",
    path: "/veterinars/:id([0-9]+)-:slug([a-z-0-9_]+)/",
    meta: _91id_93_45_91slug_93MXMXP433Som6x7q539syf88zhAx_454fhqhVTmyFTPT4wMeta || {},
    component: () => import("/usr/src/app/pages/veterinars/[id]-[slug].vue")
  },
  {
    name: "clinics-city-clinic",
    path: "/clinics/:city()/:clinic()",
    meta: _91clinic_930PLJbwaBANjXK_45oUfHoeKwricNSeLql8gm2uu9_03IIMeta || {},
    component: () => import("/usr/src/app/pages/clinics/[city]/[clinic].vue")
  },
  {
    name: "clinics-kruglosutochnye",
    path: "/clinics/kruglosutochnye",
    component: () => import("/usr/src/app/pages/clinics/kruglosutochnye.vue")
  },
  {
    name: "documents-oferta_accept",
    path: "/documents/oferta_accept",
    component: () => import("/usr/src/app/pages/documents/oferta_accept.vue")
  },
  {
    name: "documents-review-policy",
    path: "/documents/review-policy",
    component: () => import("/usr/src/app/pages/documents/review-policy.vue")
  },
  {
    name: "profile-clinic-services",
    path: "/profile-clinic/services",
    meta: { ...(services61oM61XmpdM44ao8_45pqD9KeDTyRetzgYZ1vd9puIPHIMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/services.vue")
  },
  {
    name: "profile-clinic-showcase",
    path: "/profile-clinic/showcase",
    meta: { ...(showcaseggulTt8Nl5LWHC0AgPvveeYWWklBLzmp8FHZgc66kOIMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/showcase.vue")
  },
  {
    name: "profile-doctor-schedule",
    path: "/profile-doctor/schedule",
    meta: { ...(schedulehNvQ45klYrZuRgSDYd_Yu5ALAvlCCXxJ0HxRD7OYqWYMeta || {}), ...{"middleware":["auth","doctor-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-doctor/schedule.vue")
  },
  {
    name: "profile-documents",
    path: "/profile/documents",
    meta: { ...(indexG2DawEp1_45VmCOYjmosjPo6ziUchO5wwph1TvzzynvL4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile/documents/index.vue")
  },
  {
    name: "shop-korzina-oformlenie",
    path: "/shop/korzina/oformlenie",
    component: () => import("/usr/src/app/pages/shop/korzina/oformlenie.vue")
  },
  {
    name: "uslugi-segment-node",
    path: "/uslugi/:segment([a-z-0-9_]+)/:node([a-z-0-9_]+)",
    meta: _91node_93wWvyVWgopz7nVAd0_45MhA7NOrb0sSoraU2MB1lN_45cZeAMeta || {},
    component: () => import("/usr/src/app/pages/uslugi/[segment]/[node].vue")
  },
  {
    name: "widget-doctor-id-fail",
    path: "/widget/doctor/:id()/fail",
    meta: failA2MkXUAwyCbr__aEFMO5ik0r1n_xEF6RNyvqjjURqcYMeta || {},
    component: () => import("/usr/src/app/pages/widget/doctor/[id]/fail.vue")
  },
  {
    name: "book-appointment-success",
    path: "/book-appointment/success",
    component: () => import("/usr/src/app/pages/book-appointment/success.vue")
  },
  {
    name: "documents-privacy-policy",
    path: "/documents/privacy-policy",
    component: () => import("/usr/src/app/pages/documents/privacy-policy.vue")
  },
  {
    name: "documents-terms-of-usage",
    path: "/documents/terms-of-usage",
    component: () => import("/usr/src/app/pages/documents/terms-of-usage.vue")
  },
  {
    name: "profile-clinic-education",
    path: "/profile-clinic/education",
    meta: { ...(educationbFnjzjeKnDJns_Te2S6_452visthSHLySWy1zHOsaT_d0Meta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/education.vue")
  },
  {
    name: "profile-doctor-education",
    path: "/profile-doctor/education",
    meta: { ...(education0ULtRp_45mFIhV0n8J_V6qm2lzlN9vjq1N0nD9_g0DLEcMeta || {}), ...{"middleware":["auth","doctor-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-doctor/education.vue")
  },
  {
    name: "widget-doctor-id",
    path: "/widget/doctor/:id()",
    meta: index40cJSBAMgYEZT77COcGem1bNavNGxYnE9WFEYjshjGcMeta || {},
    component: () => import("/usr/src/app/pages/widget/doctor/[id]/index.vue")
  },
  {
    name: "profile-clinic-requisites",
    path: "/profile-clinic/requisites",
    meta: { ...(requisitesuvyp2_wI6MRzE_45Vi_45jY_uGz2XbIu9RUqjTuNAiBRnMYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile-clinic/requisites.vue")
  },
  {
    name: "profile-clinic-statistics",
    path: "/profile-clinic/statistics",
    meta: { ...(statisticsIJrttnjuiIC6FcCwxVR_45V2N60dZ8IBAvB44JvOsj6xkMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/statistics.vue")
  },
  {
    name: "profile-doctor-statistics",
    path: "/profile-doctor/statistics",
    meta: { ...(statisticsvkQvFF4upyIMG4XXCouKwu2qRpCD22Sew9shFRdgv_EMeta || {}), ...{"middleware":["auth","doctor-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-doctor/statistics.vue")
  },
  {
    name: "documents-account-deletion",
    path: "/documents/account-deletion",
    component: () => import("/usr/src/app/pages/documents/account-deletion.vue")
  },
  {
    name: "profile-clinic-doctors-new",
    path: "/profile-clinic/doctors/new",
    meta: { ...(newJxgygup_R20WD935aZdqtSio7YhCg570RPyfTNvUgz8Meta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/doctors/new.vue")
  },
  {
    name: "profile-clinic-orders-id",
    path: "/profile-clinic/orders/:id()",
    meta: { ...(_91id_93gym9mEFnYMmr_IRs0kh6fo0XMWUGPVJiD_ZUEhmOZQoMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/orders/[id].vue")
  },
  {
    name: "profile-history-id",
    path: "/profile/history/:id()",
    meta: { ...(indexmJFPzS1gfoZZ_45HxsY5b0KH8CeRny6Q0iVUjvWx8cMFcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile/history/[id]/index.vue")
  },
  {
    name: "widget-doctor-id-booking",
    path: "/widget/doctor/:id()/booking",
    meta: bookingqj1EQvjmBeVxoap8yzBt1fsbY_4561RnDURHkexUM6AGsMeta || {},
    component: () => import("/usr/src/app/pages/widget/doctor/[id]/booking.vue")
  },
  {
    name: "widget-doctor-id-success",
    path: "/widget/doctor/:id()/success",
    meta: successYg1aTvhBTD0aVbprgwN_45ODqSPFG3MfyyTpGQ15zOyoQMeta || {},
    component: () => import("/usr/src/app/pages/widget/doctor/[id]/success.vue")
  },
  {
    name: "clinics-city-metro-slug",
    path: "/clinics/:city()/metro/:slug()",
    meta: _91slug_93sFDDm_45CQNECiIJwE41f14EMKUHK7e3PemEG0JmYb03wMeta || {},
    component: () => import("/usr/src/app/pages/clinics/[city]/metro/[slug].vue")
  },
  {
    name: "clinics-city-okrug-slug",
    path: "/clinics/:city()/okrug/:slug()",
    meta: _91slug_93UzrKpsx9JjsjmLSG_abY9FuGFmQSqXTHwH8iVWqArlEMeta || {},
    component: () => import("/usr/src/app/pages/clinics/[city]/okrug/[slug].vue")
  },
  {
    name: "clinics-city-rayon-slug",
    path: "/clinics/:city()/rayon/:slug()",
    meta: _91slug_93fjH_45oYO4mA___45OFWKKORsmNLzc5VIU6QGpPuuQdcRY4Meta || {},
    component: () => import("/usr/src/app/pages/clinics/[city]/rayon/[slug].vue")
  },
  {
    name: "profile-clinic-orders",
    path: "/profile-clinic/orders",
    meta: { ...(indexsUPTxbvyTRMGgRcR9gQKlRpBdrVpDJZTgxk9S_45TUJmoMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/orders/index.vue")
  },
  {
    name: "profile-clinic-widget",
    path: "/profile-clinic/widget",
    meta: { ...(indexzcpJE3Ukxr9NVNW_M3JEcn9A5NsRskmgAHkYEwNkgaEMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/widget/index.vue")
  },
  {
    name: "profile-history-id-report",
    path: "/profile/history/:id()/report",
    meta: { ...(report6afd_45nj_456KiPdPHS1NMd7MRAZHPBSPvx3zx1pA7s5IIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile/history/[id]/report.vue")
  },
  {
    name: "veterinar-rating-where",
    path: "/veterinar-rating/:where(.*)*",
    component: () => import("/usr/src/app/pages/veterinar-rating/[...where].vue")
  },
  {
    name: "documents-accreditation-info",
    path: "/documents/accreditation-info",
    component: () => import("/usr/src/app/pages/documents/accreditation-info.vue")
  },
  {
    name: "profile-clinic-doctors",
    path: "/profile-clinic/doctors",
    meta: { ...(index6mrXNohdFExYXzItzOGUHUD0qN94CRkbKA7lkGLvazEMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/doctors/index.vue")
  },
  {
    name: "profile-clinic-notifications",
    path: "/profile-clinic/notifications",
    meta: { ...(notifications6hVCiwG3aCWAoomaeCX35PK7j9ACQk0UxH8oDnnBSRMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile-clinic/notifications.vue")
  },
  {
    name: "profile-doctor-history",
    path: "/profile-doctor/history",
    meta: { ...(indexgkekFZhyurAM7TQCOasIWF7TYCQMqF2NxUClYOIvOOwMeta || {}), ...{"middleware":["auth","doctor-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-doctor/history/index.vue")
  },
  {
    name: "profile-doctor-schedule-date",
    path: "/profile-doctor/schedule-date",
    meta: schedule_45datep_45Eo5FgCNL4UVZVs2SWVVKjB7OgaFtEuowqKjHbEEcEMeta || {},
    component: () => import("/usr/src/app/pages/profile-doctor/schedule-date.vue")
  },
  {
    name: "profile-clinic-finances",
    path: "/profile-clinic/finances",
    meta: { ...(indexR5np3PUWxHM7cD1i8s6Jm0fiD6uBYFGoi9CpAdgl4y0Meta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/finances/index.vue")
  },
  {
    name: "profile-clinic-preview-slug",
    path: "/profile-clinic/preview/:slug()",
    meta: { ...(_91slug_93VZ_epLqunfA4LWW57ZY5xagBT_8Vbiex4HaksEQJW5QMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/preview/[slug].vue")
  },
  {
    name: "profile-clinic-widget-preview",
    path: "/profile-clinic/widget/preview",
    meta: { ...(previewQl3kSGuFMgOyguMXsMHY_45qSdyHFYR_45lHK4jdoqw7x5sMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/widget/preview.vue")
  },
  {
    name: "profile-clinic-widget-tariffs",
    path: "/profile-clinic/widget/tariffs",
    meta: { ...(tariffsYy1rYmtc0YnBnHYN_45hqnLnZRup5kfEumwSBdaCd89dgMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/widget/tariffs.vue")
  },
  {
    name: "profile-doctor-finances",
    path: "/profile-doctor/finances",
    meta: { ...(indexqepbqrJiT69vC8DMuWU37VYUH0L_2jktRdtnGoL3HYoMeta || {}), ...{"middleware":["auth","doctor-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-doctor/finances/index.vue")
  },
  {
    name: "profile-doctor-preview-slug",
    path: "/profile-doctor/preview/:slug()",
    meta: { ...(_91slug_93VbTF32Y2Q6Cij6fTsH3osZV9PngVW0C8TeQFJlo8HEkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/usr/src/app/pages/profile-doctor/preview/[slug].vue")
  },
  {
    name: "veterinars-city-vyesd",
    path: "/veterinars/:city()/vyesd",
    meta: indexkroGwJ1zMATseCpRoC7J80UV497XuynEqvST4pq27U4Meta || {},
    component: () => import("/usr/src/app/pages/veterinars/[city]/vyesd/index.vue")
  },
  {
    name: "vyzov-veterinara-na-dom",
    path: "/vyzov-veterinara-na-dom",
    component: () => import("/usr/src/app/pages/vyzov-veterinara-na-dom/index.vue")
  },
  {
    name: "vyzov-veterinara-na-dom-uspeh",
    path: "/vyzov-veterinara-na-dom/uspeh",
    component: () => import("/usr/src/app/pages/vyzov-veterinara-na-dom/uspeh.vue")
  },
  {
    name: "documents-licenzionnyj-dogovor",
    path: "/documents/licenzionnyj-dogovor",
    component: () => import("/usr/src/app/pages/documents/licenzionnyj-dogovor.vue")
  },
  {
    name: "profile-clinic-doctors-history",
    path: "/profile-clinic/doctors/history",
    meta: {"middleware":["auth"]},
    component: () => import("/usr/src/app/pages/profile-clinic/doctors/history.vue")
  },
  {
    name: "vyzov-veterinara-na-dom-city",
    path: "/vyzov-veterinara-na-dom/:city()",
    component: () => import("/usr/src/app/pages/vyzov-veterinara-na-dom/[city].vue")
  },
  {
    name: "documents-consent-personal-data",
    path: "/documents/consent-personal-data",
    component: () => import("/usr/src/app/pages/documents/consent-personal-data.vue")
  },
  {
    name: "profile-clinic-appointment-id",
    path: "/profile-clinic/appointment-:id()",
    meta: { ...(appointment_45_91id_93n6cmSRu4TgOaL0fmrJ_Kl227CpuYGEw0Qf5prnBontAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile-clinic/appointment-[id].vue")
  },
  {
    name: "profile-clinic-doctors-schedule",
    path: "/profile-clinic/doctors/schedule/",
    meta: { ...(schedulePrFI8NaBR__45It8hiPzQgfw7cdCBJG_45v_45ucnC1DQvUbAMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/doctors/schedule.vue")
  },
  {
    name: "profile-clinic-integration-enot",
    path: "/profile-clinic/integration/enot",
    meta: { ...(enotCRIzdDXsr3jqtkhwKKC_45V_ynIi9Ujy1S2OkSwcWH_45p8Meta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/integration/enot.vue")
  },
  {
    name: "profile-doctor-appointment-id",
    path: "/profile-doctor/appointment-:id()",
    meta: { ...(appointment_45_91id_93ay7fgZin6YbRY_45wahZ5Stk_fvZhE_45Q5OO_45s2CX_45pRQsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile-doctor/appointment-[id].vue")
  },
  {
    name: "profile-doctor-partner-programs",
    path: "/profile-doctor/partner-programs",
    meta: { ...(partner_45programsZIyJXjpRajNrjHmzUWqRyGx83x2cIzxkqqbt287UXZwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile-doctor/partner-programs.vue")
  },
  {
    name: "profile-doctor-referral-program",
    path: "/profile-doctor/referral-program",
    meta: { ...(referral_45program8gbfwu9UwluzCU6s2avLG6tq0ezwl0tTcdf6aPQDnOUMeta || {}), ...{"middleware":["auth","doctor-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-doctor/referral-program.vue")
  },
  {
    name: "shop-section-category",
    path: "/shop/:section()/:category()",
    meta: indexy6tjx6syJa70uiF8gHmMFUFnSw91s4OMpGOSU4Y1lxQMeta || {},
    component: () => import("/usr/src/app/pages/shop/[section]/[category]/index.vue")
  },
  {
    name: "veterinars-online-ratolog-promo",
    path: "/veterinars/online/ratolog-promo",
    component: () => import("/usr/src/app/pages/veterinars/online/ratolog-promo.vue")
  },
  {
    name: "profile-clinic-integration",
    path: "/profile-clinic/integration",
    meta: { ...(indexUUadQ0bOslq4rjWdg_g7uYaaGtx_45_Ib5VQnTZUxpsBoMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/integration/index.vue")
  },
  {
    name: "veterinars-online-doctors-online",
    path: "/veterinars/online/doctors-online",
    component: () => import("/usr/src/app/pages/veterinars/online/doctors-online.vue")
  },
  {
    name: "profile-clinic-applications",
    path: "/profile-clinic/applications",
    meta: { ...(indexi114PZumgJiwqcvd5Dixob4_45st_vZ0Vm_n2kZGu66V8Meta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/applications/index.vue")
  },
  {
    name: "profile-clinic-integration-getwell",
    path: "/profile-clinic/integration/getwell",
    meta: { ...(getwellPA9dNgpETO2T_Zm_45DOeS0JICy4MRuZpkFmlmJIeIA_sMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/usr/src/app/pages/profile-clinic/integration/getwell.vue")
  },
  {
    name: "profile-doctor-history-id-report",
    path: "/profile-doctor/history/:id()/report",
    meta: { ...(reportlbfqwGFLzmEwBhe7aTdxwKC4AqTgdIT7Ttr5ZJye5lQMeta || {}), ...{"middleware":["auth","doctor-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-doctor/history/[id]/report.vue")
  },
  {
    name: "shop-section-category-animal",
    path: "/shop/:section()/:category()/:animal()",
    meta: _91animal_93lTikH6ogKrhEIJFQ8koUqsV1QdZcNcguCEnq97sPiEAMeta || {},
    component: () => import("/usr/src/app/pages/shop/[section]/[category]/[animal].vue")
  },
  {
    name: "clinics-city-kruglosutochno",
    path: "/clinics/:city()/kruglosutochno",
    meta: index4dl_45PBwj3yS1LlqhOpouXocG57wvKj_hm4GPbYm_89oMeta || {},
    component: () => import("/usr/src/app/pages/clinics/[city]/kruglosutochno/index.vue")
  },
  {
    name: "documents-veterinary_user_agreement",
    path: "/documents/veterinary_user_agreement",
    component: () => import("/usr/src/app/pages/documents/veterinary_user_agreement.vue")
  },
  {
    name: "profile-clinic-finances-payout-id",
    path: "/profile-clinic/finances/payout-:id()",
    meta: { ...(payout_45_91id_93C5Pf9At9FEtfy8xNGZox6He_45FA1sq7TwNsj8dnTYjEMMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/finances/payout-[id].vue")
  },
  {
    name: "profile-clinic-online-consultations",
    path: "/profile-clinic/online-consultations",
    meta: { ...(online_45consultationsMrXsBj_45LD29hEP2r9PmHVYu6SuYm6K8AaUoZ7IGnMgcMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/online-consultations.vue")
  },
  {
    name: "profile-doctor-finances-payout-id",
    path: "/profile-doctor/finances/payout-:id()",
    meta: { ...(payout_45_91id_93LofJq3nVbHrSJBLPbiEJ1BgyEPCuL_45_45LksZqS29suGAMeta || {}), ...{"middleware":["auth","doctor-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-doctor/finances/payout-[id].vue")
  },
  {
    name: "uslugi-segment-service-animal",
    path: "/uslugi/:segment([a-z-0-9_]+)/:service([a-z-0-9_]+)-:animal(zhivotnyh|koshek|sobak|drugih)",
    meta: _91service_93_45_91animal_93mn1_45H65P3J1cUJYzRN3Yqizuw_DeZ4m9_hZvYvk53g4Meta || {},
    component: () => import("/usr/src/app/pages/uslugi/[segment]/[service]-[animal].vue")
  },
  {
    name: "veterinars-city-vyesd-specialty",
    path: "/veterinars/:city()/vyesd/:specialty()",
    meta: _91specialty_93Dq0kH3KdpoLhZKKoPhCuWRlDxNGWodxOn6TJFq_459pC8Meta || {},
    component: () => import("/usr/src/app/pages/veterinars/[city]/vyesd/[specialty].vue")
  },
  {
    name: "documents-consent-personal-data-vets",
    path: "/documents/consent-personal-data-vets",
    component: () => import("/usr/src/app/pages/documents/consent-personal-data-vets.vue")
  },
  {
    name: "profile-clinic-doctors-id-schedule",
    path: "/profile-clinic/doctors/:id([0-9]+)/schedule/",
    meta: { ...(scheduletdKtGiFQTOkzakHDA7N7ktip9atZdRG26UFwEM6GA5YMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/doctors/[id]/schedule.vue")
  },
  {
    name: "profile-clinic-integration-vetmanager",
    path: "/profile-clinic/integration/vetmanager",
    meta: { ...(vetmanageru1IZmYqx0m9p1wuzEk_2iD7aUXDrDiNpzKEIhpLMrWIMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/integration/vetmanager.vue")
  },
  {
    name: "profile-clinic-partner-programs",
    path: "/profile-clinic/partner-programs",
    meta: { ...(index74B1gQlO_mic069D85FzrAUhnJvG_45YdRuY6GjOdL_45kgMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/partner-programs/index.vue")
  },
  {
    name: "profile-clinic-partner-programs-slug",
    path: "/profile-clinic/partner-programs/:slug()",
    meta: { ...(_91slug_93t5e4ZY7Z6SqJiwIO58XBc8VakuyDJEB6um2trsbSV6kMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/partner-programs/[slug].vue")
  },
  {
    name: "profile-doctor-history-media-id-view",
    path: "/profile-doctor/history/media/:id()/view",
    meta: { ...(view0SzeF60ifL0xS9jOv9K6gVFBtHdhaF_UUFBbxnnzHzoMeta || {}), ...{"middleware":["auth","doctor-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-doctor/history/media/[id]/view.vue")
  },
  {
    name: "profile-clinic-applications-kind-id",
    path: "/profile-clinic/applications/:kind()-:id()",
    meta: { ...(_91kind_93_45_91id_93PO3LotcgYZMqmMOrR3dSZ77FhbCZIsr0thC_bND8gpsMeta || {}), ...{"middleware":["auth","clinic-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-clinic/applications/[kind]-[id].vue")
  },
  {
    name: "profile-doctor-finances-commission-id",
    path: "/profile-doctor/finances/commission-:id()",
    meta: { ...(commission_45_91id_9305idMHOA4ttF8J0_456xq9ZX6pfpLXZxX5zfAVKWl5weQMeta || {}), ...{"middleware":["auth","doctor-access-control"]} },
    component: () => import("/usr/src/app/pages/profile-doctor/finances/commission-[id].vue")
  },
  {
    name: "documents-polzovatelskoe-soglashenie-so-spec",
    path: "/documents/polzovatelskoe-soglashenie-so-spec",
    component: () => import("/usr/src/app/pages/documents/polzovatelskoe-soglashenie-so-spec.vue")
  },
  {
    name: "documents-uslovija-dlja-specialistov-i-klinik",
    path: "/documents/uslovija-dlja-specialistov-i-klinik",
    component: () => import("/usr/src/app/pages/documents/uslovija-dlja-specialistov-i-klinik.vue")
  },
  {
    name: "veterinars-online-besplatnaya-onlayn-konsultaciya-veterinara",
    path: "/veterinars/online/besplatnaya-onlayn-konsultaciya-veterinara",
    component: () => import("/usr/src/app/pages/veterinars/online/besplatnaya-onlayn-konsultaciya-veterinara.vue")
  },
  {
    name: component_45stubIzjaNWEhwusarYFpWl1xoeSJ1pcPz492fZ1FsTE5NCMMeta?.name,
    path: "/blog/pochemu-sobaka-perestala-est-edu-2/",
    component: component_45stubIzjaNWEhwusarYFpWl1xoeSJ1pcPz492fZ1FsTE5NCM
  },
  {
    name: component_45stubIzjaNWEhwusarYFpWl1xoeSJ1pcPz492fZ1FsTE5NCMMeta?.name,
    path: "/veterinars/online/surgeon/",
    component: component_45stubIzjaNWEhwusarYFpWl1xoeSJ1pcPz492fZ1FsTE5NCM
  }
]